import metaPixelClient from './metaPixelClient'

export default metaPixelClient
